const checkout_form = document.querySelector('#cart-page-form');
const eco_option_main = checkout_form.querySelector('input#ecotick');

if(checkout_form) {

  checkout_form.addEventListener('submit', function(e) {

    const eco_option = this.querySelector('input#ecotick');
    const note = this.querySelector('textarea#CartSpecialInstructions');
    const label = eco_option.parentNode.querySelector('label[for=ecotick]')

    if(eco_option.checked) {
      note.value = note.value + '\r\n\r\n\r\n' + label.textContent;
    }else {
      const new_value = note.value.replace(label.textContent, '');
      note.value = new_value
    }

  })
}
if(eco_option_main) {
  eco_option_main.addEventListener('change', function() {
    const note = checkout_form.querySelector('textarea#CartSpecialInstructions');
    if(!this.checked && note.value.length > 0) {
      const label = this.parentNode.querySelector('label[for=ecotick]');
      const new_value = note.value.replace(label.textContent, '');

      note.value = new_value
    }
  })
}